import $ from 'jquery';
import nextArrowBlue from '../assets/next-arrow-blue.svg';
import prevArrowBlue from '../assets/prev-arrow-blue.svg';

export const relatedPosts = () => {
  const $relatedPostSlider = $('.related-blogs__blog-section');
  const $relatedProductSlider = $('.related-products');

  //replace img with inline svg so color can be changed based on slick-disabled class
  const replaceSVG = (arrows) => {
    arrows.each(function () {
      var $img = $(this);
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      $.get(
        imgURL,
        function (data) {
          var $svg = $(data).find('svg');

          if (typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass + ' replaced-svg');
          }

          $svg = $svg.removeAttr('xmlns:a');

          $img.replaceWith($svg);
        },
        'xml'
      );
    });
  };

  const slideCounter = (parent) => {
    let slideIndex = 1;
    const $slideTotal = parent.find('.slick-slide').length;

    const $prevArrow = parent.find('.slick-arrow.prev');

    const $slideDisplay = (slideIndex, $slideTotal) => {
      return `<div class="slide-display"><div class="slide-index">${slideIndex}</div>/<div class="slide-count">${$slideTotal}</div></div>`;
    };

    if (window.innerWidth <= 440) {
      $prevArrow.append($slideDisplay(slideIndex, $slideTotal));
    }

    window.addEventListener('resize', () => {
      const $arrows = parent.find('.slider-arrow');
      if (window.innerWidth > 440) {
        //needed because slick slider replaces arrows on breakpoints
        if (parent.find('.replaced-svg').length == 0) {
          replaceSVG($arrows);
        }

        if (parent.find('.slide-display').length != 0) {
          parent.find('.slide-display').remove();
        }
      }
      if (window.innerWidth <= 440 && $('.slide-display').length == 0) {
        $('.slick-arrow.prev').append($slideDisplay(slideIndex, $slideTotal));
        replaceSVG($arrows);
      }
    });

    parent.on('afterChange', function (event, slick, currentSlide) {
      slideIndex = currentSlide + 1;
      $('.slide-index').text(slideIndex);
    });
  };

  if ($relatedPostSlider.length != 0) {
    $relatedPostSlider.slick({
      dots: false,
      slidesToShow: 3.125,
      slidesToScroll: 1,

      infinite: false,
      prevArrow: `<figure class="prev"><img class='slider-arrow prev' src='${prevArrowBlue}' /></figure>`,
      nextArrow: `<figure class="next"><img class='slider-arrow next' src='${nextArrowBlue}' /></figure>`,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2.125,
          },
        },
        {
          breakpoint: 441,
          settings: {
            slidesToShow: 1.125,
          },
        },
      ],
    });

    const $arrows = $relatedPostSlider.find('.slider-arrow');

    replaceSVG($arrows);

    slideCounter($relatedPostSlider);
  }

  if ($relatedProductSlider.length != 0) {
    $relatedProductSlider.slick({
      dots: false,
      slidesToShow: 4.125,
      slidesToScroll: 1,

      infinite: false,
      prevArrow: `<figure class="prev"><img class='slider-arrow prev' src='${prevArrowBlue}' /></figure>`,
      nextArrow: `<figure class="next"><img class='slider-arrow next' src='${nextArrowBlue}' /></figure>`,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2.5,
          },
        },
        {
          breakpoint: 441,
          settings: {
            slidesToShow: 1.25,
          },
        },
      ],
    });

    const $arrows = $relatedProductSlider.find('.slider-arrow');

    replaceSVG($arrows);

    slideCounter($relatedProductSlider);
  }
};
